import WorkflowToken from '@apps/automation/admin/tokens/workflow'
import New from '@apps/automation/admin/views/workflows/new'
import Panel from '@admin/components/panel'
import React from 'react'

const getNew = (props, context) => ({
  program_id: context.admin.programs[0].id,
  triggers: ['maha:signup_created','maha:signup_configured'],
  params: {
    signup_page_id: props.signup_page.id
  }
})

const mapPropsToPanel = (props, context) => ({
  title: 't(ty(Workflows))',
  collection: {
    endpoint: '/api/admin/automation/workflows',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Title)', key: 'title', primary: true, format: (workflow) => (
        <WorkflowToken workflow={ workflow } compact={ true } />
      ) }
    ],
    empty: {
      title: 't(No Workflows)',
      text: 't(There are no workflows for this signup page)',
      svg: 'network',
      buttons: [
        { 
          label: 't(Create Workflow)',
          access: {
            rights: { $allOf: ['automation:access_app','automation:manage_workflows'] }
          },
          modal: <New { ...getNew(props, context) } /> 
        }
      ]
    },
    export: [
      { label: 't(ID)', key: 'id' },
      { label: 't(Title)', key: 'display_name' },
      { label: 't(Program)', key: 'program.title' },
      { label: 't(Enrolled)', key: 'enrolled_count' },
      { label: 't(Active)', key: 'active_count' },
      { label: 't(Lost)', key: 'lost_count' },
      { label: 't(Converted)', key: 'converted_count' },
      { label: 't(Completed)', key: 'completed_count' },
      { label: 't(Status)', key: 'status' }
    ],
    entity: 'worfklow',
    defaultQuery: { signup_page_id: props.signup_page.id },
    defaultSort: { key: 'created_at', order: 'desc' },
    onClick: (record) => context.router.push(`/automation/workflows/${record.id}`)
  },
  task: {
    svg: 'plus',
    access: {
      rights: { $allOf: ['automation:access_app','automation:manage_workflows'] }
    },
    modal: <New { ...getNew(props, context) } />
  }
})

export default Panel(null, mapPropsToPanel)
